function lineClamp(parraf, container) {
  const parrafLineLeight = parseFloat($(parraf).css('line-height'));
  const containerHeight = $(container).height();
  // eslint-disable-next-line radix
  const calc = parseInt((containerHeight) / parrafLineLeight);

  $(parraf).css({
    '-webkit-line-clamp': `${calc}`,
    '-webkit-box-orient': 'vertical',
  });
}

function clampVerticalTexts(tag) {
  $(`.owl-item .item.vertical .img-container ${tag}`).each(function () {
    $(this).parent().siblings('.img-info').css('max-height', $(this)[0].height);
    lineClamp($(this).parent().siblings('.img-info').find('.img-description'), $(this).parent().siblings('.img-info'));
  });
}

function getScrollPercent() {
  const h = document.documentElement;
  const b = document.body;
  const st = 'scrollTop';
  const sh = 'scrollHeight';
  // eslint-disable-next-line no-mixed-operators
  return (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
}

function whenBecomesVisible(element, callback) {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.8,
  };

  function handleIntersect(changes, observer) {
    changes.forEach((change) => {
      if (change.intersectionRatio > 0) {
        if (change.isIntersecting === true) {
          callback(change);
          observer.unobserve(change.target);
        }
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersect, options);
  observer.observe(element);
}

const showingPaywall = document.querySelector('body.paywall--in-content') !== null;

const getInnerHeight = (element) => {
  if (!element) {
    return 0;
  }
  const computedStyle = getComputedStyle(element);
  return element.clientHeight - parseFloat(computedStyle.paddingTop) - parseFloat(computedStyle.paddingBottom);
};
const getOuterHeight = (element) => {
  if (!element) {
    return 0;
  }
  const computedStyle = getComputedStyle(element);
  return element.offsetHeight + parseFloat(computedStyle.marginTop) + parseFloat(computedStyle.marginBottom);
};

const elementsOverlap = (el1, el2) => {
  const domRect1 = el1.getBoundingClientRect();
  const domRect2 = el2.getBoundingClientRect();

  return !(
    domRect1.top > domRect2.bottom
    || domRect1.right < domRect2.left
    || domRect1.bottom < domRect2.top
    || domRect1.left > domRect2.right
  );
};

const isMobile = matchMedia('(max-width: 768px)').matches;

const isMobileDevice = /iPhone|Android/i.test(navigator.userAgent);

const getDefaultCookiePaymentToastExpires = () => {
  const expires = new Date();
  expires.setHours(expires.getHours() + 12);

  return expires;
};

export {
  clampVerticalTexts,
  lineClamp,
  whenBecomesVisible,
  getScrollPercent,
  showingPaywall,
  getInnerHeight,
  getOuterHeight,
  elementsOverlap,
  isMobile,
  isMobileDevice,
  getDefaultCookiePaymentToastExpires,
};
